module.exports = __webpack_public_path__ + "uia-approve-rights.9cb3c7e0ab27c006369681bb6e3abd2d.svg";